import React from "react";

import { Accordion, Typography } from "clearsense-ui/components";

import Section from "./Section";
import { getAccordionSections } from "./utils";

const DetailsAccordion = ({ title, icon, jobDetails }) => (
  <Accordion>
    <Accordion.Item
      title={
        <div className="flex ml-2 space-x-2">
          {icon}
          <Typography style="h4" type="semibold" className="text-primary-shade">
            {title}
          </Typography>
        </div>
      }
      actionProps={{ className: "mr-2" }}
      iconTextClosed="Show details"
      iconTextOpened="Hide details"
    >
      <div className="grid gap-4 mx-2 mt-4 md:grid-cols-1 lg:grid-cols-2">
        {getAccordionSections(jobDetails).map(({ section, info }, idx) => (
          <Section section={section} info={info} key={idx} />
        ))}
      </div>
    </Accordion.Item>
  </Accordion>
);

export default DetailsAccordion;
